import fetch from '@/utils/fetch';

export function bannerSave(query) {
    return fetch({
        url: '/Cqjcom/Cqjcom/saveBanner',
        method: 'post',
        data: query
    });
}

export function bannerEdit(query) {
    return fetch({
        url: '/Cqjcom/Cqjcom/getBannerById',
        method: 'post',
        data: query
    });
}

export function bannerList(query) {
    return fetch({
        url: '/Cqjcom/Cqjcom/getBannerByCondition',
        method: 'post',
        data: query
    });
}

export function bannerRemove(query) {
    return fetch({
        url: '/Cqjcom/Cqjcom/batchDeleteBanner',
        method: 'post',
        data: query
    });
}



// WEBPACK FOOTER //
// ./src/api/banner/index.js